import React, { Component } from 'react';
import "./prospectingDetailsPage.scss";
import InternalNotes from '../CustomerTabs/InternalNotes/InternalNotes';
import DocumentsTabMain from '../CustomerTabs/DoucmentsTab/DocumentsTabMain';
import CustomerMessagesMainCC from '../CustomerTabs/CustomerMessages/CustomerMessagesMainCC';
import InteractionHistoryMainCC from '../CustomerTabs/InteractionHistory/InteractionHistoryMainCC';
import ProductsMainCC from '../CustomerTabs/Products/ProductsMainCC';
import ActionItemsMainCC from '../CustomerTabs/ActionItems/ActionItemsMainCC';
import AccountsMainCC from '../CustomerTabs/Accounts/AccountsMainCC';

import { BankUserContext } from '../../bankUserContext';
import { withContext } from '../Authentication/RoleAuthorizationClassComponent';
import { Pages, actionAuthorization } from '../../utils/RolesUtil';
import { withContextComponent, WithContextProps } from '../shared/WithContext';

type tabsList = {
  id: number;
  tabName: string;
  actionName: string;
}

type TabsMainCCState = {
  activeTab: number;
  tabsList: tabsList[];
  refreshComponent: boolean;
}

type TabMainCCProps = {
  triggerContext: any;
}



class TabsMainCC extends Component<WithContextProps<TabMainCCProps>, TabsMainCCState> {
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  // static contextType = TriggerContext;
  // context: React.ContextType<typeof TriggerContext> | undefined;
  constructor(props: WithContextProps<TabMainCCProps>) {
    super(props)
    this.state = {
      activeTab: 0,
      tabsList: [{ id: 1, tabName: "Internal Notes", actionName: actionAuthorization.viewInternalNotes }, { id: 2, tabName: "Customer Messages", actionName: actionAuthorization.viewCustomerMessages },
      { id: 3, tabName: "Documents", actionName: actionAuthorization.viewDocuments }, { id: 4, tabName: "Interaction History", actionName: actionAuthorization.viewInteractionHistory }, {
        id: 5, tabName: "Action Items",
        actionName: actionAuthorization.viewActionItem
      }, { id: 6, tabName: "Products", actionName: actionAuthorization.viewProductsTab },
      { id: 7, tabName: "Accounts", actionName: actionAuthorization.viewAccountsTab },

      ],
      refreshComponent: false
    }
  }

  componentDidMount(): void {
    const tabsData = this.state.tabsList.filter((m: tabsList) => withContext(this.context, Pages.customerDetailsPage, m.actionName, this.props.context?.productDetails?.productid));
    const activeTabId = tabsData.length > 0 ? tabsData[0].id : 0;
    this.setState({ tabsList: tabsData, activeTab: activeTabId })


  }


  tabsContainer = (param: number) => {
    const { refreshComponent } = this.state;
    switch (param) {
      case 1: return <InternalNotes refreshComponent={refreshComponent} context={this.props.context} />
      case 2: return <CustomerMessagesMainCC />
      case 3: return <DocumentsTabMain refreshComponent={refreshComponent} context={this.props.context} />
      case 4: return <InteractionHistoryMainCC refreshComponent={refreshComponent} context={this.props.context} />
      case 5: return <ActionItemsMainCC refreshComponent={refreshComponent} contextUpdating={this.contextUpdating} context={this.props.context} />
      case 6: return <ProductsMainCC refreshComponent={refreshComponent} context={this.props.context} triggerContext={this.props?.triggerContext}/>
      case 7: return <AccountsMainCC refreshComponent={refreshComponent} context={this.props.context} />
      default: return <></>
    }
  }


  componentDidUpdate(prevProps: Readonly<unknown>, prevState: Readonly<TabsMainCCState>, snapshot?: any): void {
    const clientActionId = localStorage.getItem('clientActionId'); //required to open edit pop up from action todo popup from landing page
    const status = localStorage.getItem('status')            // to open interactionHistory tab when status is completed and cancelled
    if (this.props.context?.value) {
      this.props.context?.setValue(false);
      const tabsData = this.state.tabsList.filter((m: tabsList) => withContext(this.context, Pages.customerDetailsPage, m.actionName, this.props.context?.productDetails?.productid));
      const activeTabId = tabsData.length > 0 ? tabsData[0].id : 0;
      this.setState({ refreshComponent: !this.state.refreshComponent, tabsList: tabsData, activeTab: activeTabId })
      this.props.context?.setValue(false);
      if (clientActionId) {
        if (clientActionId !== 'null' && clientActionId.length > 10) {
          this.setState({ activeTab: 5 })
        }
      }
      if(status){
        this.setState({ activeTab: 4 })
      }
    }
    
  }

  contextUpdating = () => {
    this.props.context?.setTriggerLeadDetails(true);
  }

  tabsComponent = () => {
    return (
      <div className='tabsUpperSection'>
        {this.state.tabsList.map((m: tabsList) => {
          return (<>
            {(m.id !== this.state.activeTab) ? <div className='tabsContainer' onClick={() => this.setState({ activeTab: m.id })} key={m.id}>
              <span> {m.tabName} </span>
            </div> : <div className='tabsContainer tabsActiveContainer' key={m.id}>
              <span>{m.tabName}</span>
            </div>}
          </>
          )
        })}

      </div>
    )
  }

  render() {
    return (
      <div>
        {this.tabsComponent()}
        <div className="tabsDownContainer">
          {this.tabsContainer(this.state.activeTab)}
        </div>
      </div>
    )
  }
}

export default withContextComponent<WithContextProps<TabMainCCProps>>(TabsMainCC)
